var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.iconContainer
  }, [_c('InlineSvg', {
    style: {
      color: _vm.getColorFill(_vm.iconColor)
    },
    attrs: {
      "src": require(`@assets/icons/${_vm.getFileName}.svg`)
    }
  }), _vm.fileExtension ? _c('span', {
    class: (_class = {}, _class[_vm.$style.fileExtensionText] = true, _class),
    style: {
      'font-size': _vm.getExtensionFontSize
    }
  }, [_vm._v(" " + _vm._s(_vm.fileExtension) + " ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }